module.exports = __webpack_public_path__ + "657723dc996cf0ae6b4c6110f5d4ddab.woff";